import React, { useState, useEffect, useContext } from "react";
import { useFirestore } from "../../firebase/FirestoreContext";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { EnvContext } from "../../../context/EnvContext";
import config from "../../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ShippingOptionsList = () => {
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const navigate = useNavigate();

  const collectionPath =
    environment === "staging"
      ? config.enveironment.staging.collectionPath
      : config.enveironment.production.collectionPath;

  const [shippingOptions, setShippingOptions] = useState([]);

  useEffect(() => {
    const shippingCollectionRef = collection(
      db,
      `${collectionPath}ShippingOptions/ShippingOptionsList/DataBase`
    );
    const shippingQuery = query(shippingCollectionRef, orderBy("price", "asc"));

    getDocs(shippingQuery)
      .then((querySnapshot) => {
        const shippingArray = [];
        querySnapshot.forEach((doc) => {
          shippingArray.push({ id: doc.id, ...doc.data() });
        });
        setShippingOptions(shippingArray);
      })
      .catch((error) => {
        console.error("Error fetching shipping options:", error);
        toast.error("Error loading shipping options");
      });
  }, [db, collectionPath]);

  const styles = {
    table: {
      borderCollapse: "collapse",
      width: "100%",
      backgroundColor: "white",
    },
    th: {
      border: "1px solid #d1d0d0",
      padding: "8px",
      textAlign: "left",
      backgroundColor: "rgba(49,57,66,.1)",
    },
    td: {
      border: "1px solid #d1d0d0",
      padding: "8px",
      color: "gray",
    },
    tdName: {
      border: "1px solid #d1d0d0",
      padding: "8px",
      cursor: "pointer",
      color: "#478169",
      fontWeight: "500",
    },
    clickableRow: {
      cursor: "pointer",
      transition: "background-color 0.2s",
    },
  };

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />
      <h2>All Shipping Options</h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Name</th>
            <th style={{ ...styles.th, width: "150px" }}>Delivery Days</th>
            <th style={{ ...styles.th, width: "120px" }}>Price</th>
            <th style={{ ...styles.th, width: "150px" }}>Free Threshold</th>
          </tr>
        </thead>
        <tbody>
          {shippingOptions.map((option) => (
            <tr
              key={option.id}
              style={styles.clickableRow}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "rgba(71, 129, 105, 0.1)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <td
                style={styles.tdName}
                onClick={() => navigate(`/main/shipping-options/edit/${option.id}`)}
              >
                {option.name}
              </td>
              <td style={styles.td}>
                {option.minimum_days} - {option.maximum_days} days
              </td>
              <td style={styles.td}>${option.price.toFixed(2)}</td>
              <td style={styles.td}>
                {option.free_threshold > 0
                  ? `$${option.free_threshold.toFixed(2)}`
                  : "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {shippingOptions.length === 0 && (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          No shipping options found. Create a new one to get started.
        </div>
      )}
    </div>
  );
};

export default ShippingOptionsList;
